import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { formatDate, formatDateTime, translateField, translateAction, DATE_FIELDS } from "./regrasFaturamentoUtils";

const HistoricoDialog = ({ open, onClose, loading, historicoData }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle style={{ color: "#17a2b8", textAlign: 'center' }}>
      <span style={{ display: 'inline-block', width: '100%'}}>
        Histórico de Alterações
      </span>
      <IconButton
        edge="end"
        color="inherit"
        onClick={onClose}
        aria-label="close"
        style={{ position: 'absolute', right: 30, top: 20, padding: 0 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          Carregando histórico...
        </div>
      ) : historicoData.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
          Nenhum histórico encontrado para esta regra.
        </div>
      ) : (
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          {historicoData.map((item, index) => (
            <div
              key={item.id}
              style={{
                padding: '15px',
                borderBottom: index < historicoData.length - 1 ? '1px solid #eee' : 'none',
                marginBottom: '10px'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <strong style={{ color: '#3f51b5' }}>{translateAction(item.action)}</strong>
                <span style={{ color: '#666', fontSize: '0.9em' }}>
                  {formatDateTime(item.changed_at)}
                </span>
              </div>
              {item.field_name && (
                <div style={{ paddingLeft: '10px' }}>
                  <div style={{ color: '#666', fontSize: '0.95em' }}>
                    <strong>Campo:</strong> {translateField(item.field_name)}
                  </div>
                  <div style={{ marginTop: '5px', display: 'flex', gap: '20px' }}>
                    <div>
                      <span style={{ color: '#999', fontSize: '0.9em' }}>Antes: </span>
                      <span style={{
                        backgroundColor: '#ffebee',
                        padding: '2px 8px',
                        borderRadius: '4px',
                        color: '#c62828'
                      }}>
                        {item.old_value
                          ? (DATE_FIELDS.includes(item.field_name) ? formatDate(item.old_value) : item.old_value)
                          : '(vazio)'}
                      </span>
                    </div>
                    <div>
                      <span style={{ color: '#999', fontSize: '0.9em' }}>Depois: </span>
                      <span style={{
                        backgroundColor: '#e8f5e9',
                        padding: '2px 8px',
                        borderRadius: '4px',
                        color: '#2e7d32'
                      }}>
                        {item.new_value
                          ? (DATE_FIELDS.includes(item.field_name) ? formatDate(item.new_value) : item.new_value)
                          : '(vazio)'}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              {!item.field_name && (
                <div style={{ paddingLeft: '10px', color: '#666', fontSize: '0.95em' }}>
                  Registro {item.action === 'CREATE' ? 'criado' : 'removido'}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Fechar
      </Button>
    </DialogActions>
  </Dialog>
);

export default HistoricoDialog;
